import React from 'react';
import { Card, CardBody, Container, Spinner } from 'reactstrap';
import useGet from '../../helpers/hooks/useGet';
import AdvisorySessionsList from './advisorySessionsList';

function AdvisorySessions() {
  const [sessions, error, loading, call] = useGet(
    `/advisory-sessions?filter=${encodeURIComponent(
      JSON.stringify({
        order: 'createdAt DESC',
        include: [
          { relation: 'farmer' },
          { relation: 'expertise' },
          { relation: 'advisory' },
        ],
      })
    )}`,
    true
  );
  return (
    <>
      <div className='page-content'>
        <Container fluid>
          <div className='align-items-end d-flex justify-content-between mb-3'>
            <h4>Advisory Sessions</h4>
          </div>
          <Card>
            <CardBody>
              {loading ? (
                <div className='text-center'>
                  <Spinner className='mr-2' color='primary' />
                </div>
              ) : (
                <AdvisorySessionsList sessions={sessions} />
              )}
            </CardBody>
          </Card>
        </Container>
      </div>
    </>
  );
}

export default AdvisorySessions;
